import axios from "axios";
import Result from "../../utils/serviceResultPattern";

export default {
  getAgentCommissions(supplierId, agentId) {
    return axios
      .get("/api/people/GetAgentCommissions", {
        params: { supplierId, agentId },
      })
      .then((res) => {
        if (!res || res.status !== 200 || !res.data) {
          return Result.error("Commissions not found");
        }
        return Result.ok(res.data);
      })
      .catch((error) => {
        return Result.error(error);
      });
  },

  getChannelCommissions(supplierId, channelId) {
    return axios
      .get("/api/people/GetChannelCommissions", {
        params: { supplierId, channelId },
      })
      .then((res) => {
        if (!res || res.status !== 200 || !res.data) {
          return Result.error("Channel commissions not found");
        }
        return Result.ok(res.data);
      })
      .catch((error) => {
        return Result.error(error);
      });
  },
};



// WEBPACK FOOTER //
// ./src/api/agents/agentService.js